import React, { ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import AppIcons from "../../utils/AppIcons";

interface IFormContaier {
  title: string;
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void | (() => void);
  children: ReactNode;
  headButton?: ReactNode;
  hint?: string;
  css?: string;
}

function FormContainer({
  title,
  onSubmit,
  children,
  headButton,
  hint = "",
  css = "",
}: IFormContaier) {
  // if we do not have a head button, display the title centered
  const buttonCss = headButton ? "text-left m-0" : "text-center m-0";
  const containerCss =
    "flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0 " +
    css;

  return (
    <div className={containerCss}>
      <div className="w-full rounded-lg md:mt-0 sm:max-w-3xl xl:p-0">
        <form onSubmit={onSubmit} className="space-y-4 md:space-y-6" action="#">
          <div className="flex flex-row my-12">
            <div className="flex-grow content-center">
              <h1 className={buttonCss}>
                {title}
                {hint === "asset" && (
                  <span className="tooltip-hint">
                    <a
                      data-tooltip-id="form-tooltip"
                      data-tooltip-place="right"
                    >
                      {AppIcons.INFO}
                    </a>
                    <Tooltip id="form-tooltip">
                      Refers to a single cultural heritage item, either movable
                      <br />
                      or immovable, that is recognized for its historical,
                      <br />
                      artistic, scientific, or social significance.
                    </Tooltip>
                  </span>
                )}
                {hint === "site" && (
                  <span className="tooltip-hint">
                    <a
                      data-tooltip-id="form-tooltip"
                      data-tooltip-place="right"
                    >
                      {AppIcons.INFO}
                    </a>
                    <Tooltip id="form-tooltip">
                      Refers to a coherent set of single cultural heritage{" "}
                      <br />
                      assets that are spatially, functionally, or thematically
                      <br />
                      connected, for example, assets of the same archaeological
                      <br />
                      site, architectural complex, or collection.
                    </Tooltip>
                  </span>
                )}
              </h1>
            </div>
            <div className="content-center">{headButton}</div>
          </div>
          {children}
        </form>
      </div>
    </div>
  );
}

export default FormContainer;
